<template>
  <div class="article white">
    <v-container>
      <h1 class="primary--text">{{ article.title }}</h1>
      <p class="pt-2 pb-5">{{ article.dateCreated }}</p>
      <v-img :src="article.backgroundImage"></v-img>
      <p class="pt-5 text-justify" v-html="article.description"></p>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment';

import Repository from "@/api/repositories";
const MediaArtcleApi = Repository.get("mediaArticles");

  export default {
    name: "MediaArticle",
    computed: {
      articleId: () => {
        return this.id;
      }
    },
    data() {
      return {
        id: this.$route.params.id,
        article: []
      }
    },
    mounted() {
      this.getMediaArticle();
    },
    methods: {
      async getMediaArticle() {
        try {
          const { data } = await MediaArtcleApi.show(this.id);
          console.log(data);

          if (data) {
            let apiData = data.data;

            if (data) {
              var article = {
                title: apiData.title,
                description: apiData.description,
                backgroundImage: apiData.background_image.main,
                dateCreated: moment(apiData.created_at).format("Do MMMM YYYY")
              }
            }

            this.article = article;
          }

          console.log('[media-article]', data, this.article);
        }
        catch(error) {
          console.log(error);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.article {
  padding: 150px 20px 120px 20px;
}
</style>